export default __webpack_public_path__ + "static/media/pictogramBeaconFile64.88acc45b.svg";